import React from "react";
import { IconHome } from '@sfx/icons';

import classnames from 'classnames';

var Breadcrumb = function Breadcrumb(props) {
  var links = props.links;
  var breadcrumbs = links && links.length > 0 && links.map(function (item, index) {
    var isOnlyHome = index + 1 === links.length;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement("span", null, isOnlyHome && links.length > 1 ? item.name : /*#__PURE__*/React.createElement("div", {
      className: classnames({
        'amBreadcrumbItem': !isOnlyHome
      }),
      onClick: links.length > 1 && typeof item.onClick === 'function' ? item.onClick : function () {
        return;
      }
    }, index === 0 && /*#__PURE__*/React.createElement(IconHome, {
      size: "18"
    }), " \xA0", item.name)), isOnlyHome ? '' : /*#__PURE__*/React.createElement("i", null, " \xA0 / \xA0"));
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "amBreadcrumb"
  }, breadcrumbs);
};

export default Breadcrumb;